export default __webpack_public_path__ + "static/clock_skew_basic_op_edit-4fe5a946cce7f74263b4689f0f054a7f.png";